import React, { useState } from "react";
import "./QuoteSection.css";
import layout from "../../assets/img/quotesection_layout.png";
import Axios from "axios";
import GA from "../functions/GA";
import { useDispatch, useSelector } from "react-redux";
import selectCorrectUrls from "../../selectCorrectUrls";
import start_quote from "../../assets/vids/start_quote.mp4";
import emptyCaptions from "../../components/empty-captions.vtt";

const QuoteSection = ({ responsiveStatus }) => {
  const [backgroundVideo, setBackgroundVideo] = useState(start_quote);
  const [zipCode, setZipCode] = useState("");
  const dispatch = useDispatch();
  const campaign = useSelector((state) => state.campaignReducer);

  const isMobile =
    responsiveStatus === "isMobile" || responsiveStatus === "isSmallMobile";

  const getTodaysDate = () => {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, "0");
    let mm = String(today.getMonth() + 1).padStart(2, "0");
    let yyyy = today.getFullYear();

    today = yyyy + "/" + mm + "/" + dd;

    return today;
  };

  const getCurrentTime = () => {
    var d = new Date();
    d.getHours();
    d.getMinutes();
    d.getSeconds();

    let time = new Date().toTimeString().slice(0, 8);

    return time;
  };

  const selectCorrectHrefForTheZip = (e) => {
    const firstTwo = zipCode.substring(0, 2);

    if (
      firstTwo === "73" ||
      firstTwo === "75" ||
      firstTwo === "76" ||
      firstTwo === "77" ||
      firstTwo === "78" ||
      firstTwo === "88" ||
      firstTwo === "79"
    ) {
      return `${
        selectCorrectUrls().quotePortal
        // }/uaicins/txsale/quick/start/UAIS?campaign=${campaign}`;
      }/selfquotetx/#/selfquote/`;
    } else if (firstTwo === "32" || firstTwo === "33" || firstTwo === "34") {
      return `${
        selectCorrectUrls().quotePortal
        // }/uaicins/sale/quick/index/UAI?campaign=${campaign}`;
      }/selfquote/#/selfquote/`;
    } else {
      return "javascript:void(0)";
    }
  };

  const checkZipCodeValidation = () => {
    const firstTwo = zipCode.substring(0, 2);

    if (
      firstTwo === "73" ||
      firstTwo === "75" ||
      firstTwo === "76" ||
      firstTwo === "77" ||
      firstTwo === "78" ||
      firstTwo === "88" ||
      firstTwo === "79" ||
      firstTwo === "32" ||
      firstTwo === "33" ||
      firstTwo === "34"
    ) {
      Axios.post(
        `${
          selectCorrectUrls().insuredPortal
        }/insurednew/insured/sqzl/index?zipcode=${zipCode}&status=Y&time=${getCurrentTime()}&date=${getTodaysDate()}`
      )
        .then((response) => {})
        .catch((e) => {});
    } else {
      Axios.post(
        `${
          selectCorrectUrls().insuredPortal
        }/insurednew/insured/sqzl/index?zipcode=${zipCode}&status=N&time=${getCurrentTime()}&date=${getTodaysDate()}`
      )
        .then((response) => {})
        .catch((e) => {});
    }
  };

  function numbersOnly(e) {
    var key = e.which || e.keyCode;
    var controlKeys = [8, 9, 13];
    var isControlKey =
      e.ctrlKey || controlKeys.join(",").match(new RegExp(key));
    if (isControlKey) {
      return;
    }
    if (!(48 <= key && key <= 57)) {
      e.preventDefault();
      return;
    }
  }

  return (
    <div style={styles.container}>
      <div
        className={`${
          responsiveStatus === "isDesktop"
            ? "row"
            : responsiveStatus === "isTablet" ||
              responsiveStatus === "isTabletLandscape"
            ? "row"
            : "row-m"
        }`}
        style={{ width: "100%", marginLeft: "0px" }}
      >
        {(responsiveStatus === "isMobile" ||
          responsiveStatus === "isSmallMobile") && (
          <div
            className={
              responsiveStatus === "isDesktop" ||
              responsiveStatus === "isTablet" ||
              responsiveStatus === "isTabletLandscape"
                ? "w-50 col-md-6 col-sm-12"
                : "w-100 col-md-6 col-sm-12"
            }
            style={{
              textAlign:
                responsiveStatus === "isDesktop"
                  ? "left"
                  : responsiveStatus === "isTablet" ||
                    responsiveStatus === "isTabletLandscape"
                  ? "left"
                  : "left",
            }}
          >
            <div style={styles.rightPaneM}>
              <h4 className="blue-underline" style={styles.subTitleM}>
                Get started with us!
              </h4>
              <div></div>
              <h1 style={styles.titleM}>
                Make Your Journey More Confident
                <br /> And Secure!
              </h1>
              <p style={styles.description}>
                Enter zip code to get started with online quote
              </p>
              <div style={styles.formM}>
                <input
                  type="tel"
                  id="zip-input-box-1"
                  value={zipCode}
                  placeholder="Enter zip code"
                  className="zip-input"
                  maxLength="5"
                  style={styles.input}
                  onChange={(e) => {
                    // Sanitize input: allow only digits, max 5
                    const sanitized = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 5);
                    setZipCode(sanitized);
                  }}
                  onPaste={(e) => {
                    e.preventDefault();
                    const pasted = e.clipboardData.getData("text");
                    const digitsOnly = pasted.replace(/\D/g, "").slice(0, 5);
                    if (digitsOnly) {
                      setZipCode((prev) => (prev + digitsOnly).slice(0, 5));
                    }
                  }}
                  onKeyDown={(e) => {
                    const isDigit = /^[0-9]$/.test(e.key);
                    const allowedControlKeys = [
                      "Backspace",
                      "Tab",
                      "ArrowLeft",
                      "ArrowRight",
                      "Delete",
                    ];
                    const isControlCombo = e.ctrlKey || e.metaKey;

                    // Allow digits, control keys, or ctrl/cmd shortcuts
                    if (
                      !isDigit &&
                      !allowedControlKeys.includes(e.key) &&
                      !isControlCombo
                    ) {
                      e.preventDefault();
                    }

                    if (e.key === "Enter") {
                      const currentZip = e.target.value;

                      if (
                        selectCorrectHrefForTheZip(currentZip) ===
                          "javascript:void(0)" ||
                        currentZip.length !== 5
                      ) {
                        GA(
                          "Start_Quote_FAILED",
                          `ZIP: ${currentZip} - zip code entered and rejected`
                        );
                        dispatch({
                          type: "SET_ERROR_MESSAGE",
                          payload: true,
                        });
                        dispatch({
                          type: "SET_MESSAGE",
                          payload: "Please enter a 5 digit zip code",
                        });
                        e.preventDefault();
                      } else {
                        GA(
                          "Start_Quote_SUCCESSFUL",
                          `ZIP: ${currentZip} - clicked on Start Quote button`
                        );
                        window.open(selectCorrectHrefForTheZip(currentZip));
                      }

                      if (currentZip === "") {
                        dispatch({
                          type: "SET_ERROR_MESSAGE",
                          payload: true,
                        });
                        dispatch({
                          type: "SET_MESSAGE",
                          payload: "Please enter a 5 digit zip code",
                        });
                      } else if (
                        selectCorrectHrefForTheZip(currentZip) ===
                        "javascript:void(0)"
                      ) {
                        checkZipCodeValidation();
                        dispatch({
                          type: "SET_ERROR_MESSAGE",
                          payload: true,
                        });
                        dispatch({
                          type: "SET_MESSAGE",
                          payload:
                            "Buy online currently not available in this zip code",
                        });
                        GA(
                          "Start_Quote_FAILED",
                          `ZIP: ${currentZip} - zip code entered and rejected`
                        );
                      }
                    }
                  }}
                />

                <button style={styles.button}>Start Quote</button>
              </div>
            </div>
          </div>
        )}

        <div
          className={
            responsiveStatus === "isDesktop" ||
            responsiveStatus === "isTablet" ||
            responsiveStatus === "isTabletLandscape"
              ? "w-50 col-md-6 col-sm-12"
              : "w-100 col-md-6 col-sm-12"
          }
        >
          <div
            style={
              responsiveStatus === "isDesktop"
                ? styles.leftPane
                : responsiveStatus === "isTablet" ||
                  responsiveStatus === "isTabletLandscape"
                ? styles.leftPane
                : styles.leftPaneM
            }
          >
            <div
              className={`${
                responsiveStatus === "isDesktop"
                  ? "iframe-shape1"
                  : responsiveStatus === "isTablet" ||
                    responsiveStatus === "isTabletLandscape"
                  ? "iframe-shape1"
                  : "iframe-shape1M"
              }`}
            >
              <div
                className={`${
                  responsiveStatus === "isDesktop"
                    ? "iframe-shape"
                    : responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                    ? "iframe-shape"
                    : "iframe-shapeM"
                }`}
              >
                <div
                  className={`${
                    responsiveStatus === "isDesktop"
                      ? "iframe-cover1"
                      : responsiveStatus === "isTablet" ||
                        responsiveStatus === "isTabletLandscape"
                      ? "iframe-cover1"
                      : "iframe-cover1M"
                  }`}
                >
                  {/* <iframe
                    src={backgroundVideo}
                    frameBorder="0"
                    allow="autoplay; fullscreen"
                    allowFullScreen
                    title="Background Video"
                  ></iframe> */}
                  <video
                    // src={backgroundVideo}
                    src={require("../../assets/vids/start_quote.mp4")}
                    autoPlay
                    muted
                    loop
                    style={{
                      objectFit: "cover",
                      zIndex: 1,
                      width: "100%",
                      height: "100%",
                      transformOrigin: "center center",
                      overflow: "hidden",
                    }}
                  >
                    {" "}
                    <track
                      kind="captions"
                      src={emptyCaptions}
                      srcLang="en"
                      label="English"
                    />
                  </video>
                  {/* <video
                    src={backgroundVideo}
                    autoPlay
                    loop
                    muted
                    playsInline
                    style={{
                      position: "absolute",
                      left:
                        responsiveStatus === "isDesktop"
                          ? "-12em"
                          : responsiveStatus === "isTablet" ||
                            responsiveStatus === "isTabletLandscape"
                          ? "-12em"
                          : "",
                    }}
                  ></video> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        {responsiveStatus !== "isMobile" &&
          responsiveStatus !== "isSmallMobile" && (
            <div className="col-md-6 col-12">
              <div style={styles.rightPane}>
                <h2 className="carousel-title-m mb-3">
                  Get
                  <span
                    style={{
                      borderBottom: "2px solid #0E72D6",
                      paddingBottom: "10px",
                    }}
                  >
                    {" "}
                    started with{" "}
                  </span>
                  us!
                </h2>
                {/* <div className="blue-underline"></div> */}
                <h1 style={styles.title}>
                  Make Your Journey More Confident <br />
                  And Secure!
                </h1>
                <p style={styles.description}>
                  Enter zip code to get started with online quote
                </p>
                <div style={styles.form}>
                  <input
                    type="tel"
                    id="zip-input-box-1"
                    value={zipCode}
                    placeholder="Enter zip code"
                    className="zip-input"
                    maxLength="5"
                    style={styles.input}
                    onChange={(e) => {
                      // Sanitize input: allow only digits, max 5
                      const sanitized = e.target.value
                        .replace(/\D/g, "")
                        .slice(0, 5);
                      setZipCode(sanitized);
                    }}
                    onPaste={(e) => {
                      e.preventDefault();
                      const pasted = e.clipboardData.getData("text");
                      const digitsOnly = pasted.replace(/\D/g, "").slice(0, 5);
                      if (digitsOnly) {
                        setZipCode((prev) => (prev + digitsOnly).slice(0, 5));
                      }
                    }}
                    onKeyDown={(e) => {
                      const isDigit = /^[0-9]$/.test(e.key);
                      const allowedControlKeys = [
                        "Backspace",
                        "Tab",
                        "ArrowLeft",
                        "ArrowRight",
                        "Delete",
                      ];
                      const isControlCombo = e.ctrlKey || e.metaKey;

                      // Allow digits, control keys, or ctrl/cmd shortcuts
                      if (
                        !isDigit &&
                        !allowedControlKeys.includes(e.key) &&
                        !isControlCombo
                      ) {
                        e.preventDefault();
                      }

                      // Handle Enter key logic
                      if (e.key === "Enter") {
                        if (
                          selectCorrectHrefForTheZip() ===
                            "javascript:void(0)" ||
                          zipCode.length !== 5
                        ) {
                          GA(
                            "Start_Quote_FAILED",
                            `ZIP: ${zipCode} - zip code entered and rejected`
                          );
                          dispatch({
                            type: "SET_ERROR_MESSAGE",
                            payload: true,
                          });
                          dispatch({
                            type: "SET_MESSAGE",
                            payload: "Please enter a 5 digit zip code",
                          });
                          e.preventDefault();
                        } else {
                          GA(
                            "Start_Quote_SUCCESSFUL",
                            `ZIP: ${zipCode} - clicked on Start Quote button`
                          );
                          window.open(selectCorrectHrefForTheZip());
                        }

                        if (zipCode === "") {
                          dispatch({
                            type: "SET_ERROR_MESSAGE",
                            payload: true,
                          });
                          dispatch({
                            type: "SET_MESSAGE",
                            payload: "Please enter a 5 digit zip code",
                          });
                        } else if (
                          selectCorrectHrefForTheZip() === "javascript:void(0)"
                        ) {
                          checkZipCodeValidation();
                          dispatch({
                            type: "SET_ERROR_MESSAGE",
                            payload: true,
                          });
                          dispatch({
                            type: "SET_MESSAGE",
                            payload:
                              "Buy online currently not available in this zip code",
                          });
                          GA(
                            "Start_Quote_FAILED",
                            `ZIP: ${zipCode} - zip code entered and rejected`
                          );
                        }
                      }
                    }}
                  />

                  <button
                    onClick={(e) => {
                      checkZipCodeValidation();
                      if (
                        selectCorrectHrefForTheZip() === "javascript:void(0)"
                      ) {
                        e.preventDefault();
                      } else {
                        window.open(selectCorrectHrefForTheZip());
                      }
                    }}
                    // style={styles.button}

                    style={{
                      ...styles.button,
                      marginTop: isMobile ? "11px" : "",
                      height: "37px", // optional: smaller button on mobile
                      padding: "0px 20px", // optional: tighter padding on mobile
                    }}
                  >
                    Start Quote
                  </button>
                </div>
              </div>
            </div>
          )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    minHeight: "400px",
    fontFamily: "Arial, sans-serif",
    backgroundImage: `url(${layout})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  leftPane: {
    flex: 1,
    // minWidth: "300px",
    padding: "20px",
  },
  leftPaneM: {
    flex: 1,
    // minWidth: "300px",
    padding: "20px",
    width: "50%",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  rightPane: {
    flex: 1,
    padding: "40px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    minWidth: "300px",
  },
  rightPaneM: {
    flex: 1,
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "left",
    minWidth: "auto",
  },
  subTitle: {
    fontSize: "18px",
    color: "#1a1a1a",
    marginBottom: "10px",
  },
  subTitleM: {
    fontSize: "16px",
    color: "#1a1a1a",
    marginBottom: "10px",
    fontWeight: "600",
  },
  underline: {
    width: "110px",
    height: "1px",
    backgroundColor: "#0066ff",
    marginBottom: "20px",
  },
  title: {
    fontSize: "30px",
    fontWeight: "bold",
    marginBottom: "20px",
    color: "#000",
  },
  titleM: {
    fontSize: "13px",
    fontWeight: "bold",
    marginBottom: "20px",
    color: "#000",
  },
  description: {
    fontSize: "16px",
    color: "#444",
    marginBottom: "20px",
  },
  form: {
    display: "flex",
    gap: "10px",
    width: "80%",
  },
  formM: {
    display: "flex",
    gap: "10px",
    width: "100%",
    marginBottom: "20px",
  },
  formM1: {
    display: "flex",
    gap: "10px",
    width: "50%",
    marginBottom: "20px",
  },
  input: {
    flex: 1,
    padding: "8px",
    fontSize: "14px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    width: "50%",
    maxWidth: "250px",
  },
  button: {
    padding: "8px 20px",
    backgroundColor: "#0066ff",
    color: "#fff",
    border: "none",
    fontSize: "14px",
    borderRadius: "4px",
    cursor: "pointer",
    fontWeight: 500,
  },
};

export default QuoteSection;
